import script from "./ChargesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ChargesTab.vue?vue&type=script&setup=true&lang=js"

import "./ChargesTab.vue?vue&type=style&index=0&id=8e67621e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e67621e"]])

export default __exports__